import React, { useState } from "react";
import { useIntl } from "react-intl";
import { RiCloseLine } from "react-icons/ri";

import CustomModal from "../../../../components/CustomModal";

import {
  Container,
  Header,
  Title,
  CloseButton,
  Description,
  StyledCheckbox,
  Footer,
  CancelButton,
  ConfirmButton,
} from "./styles";

const GrantExhibitorAccessModal = ({
  id,
  open,
  handleClose,
  isRemovingPermission = false,
  confirmation,
}) => {
  const intl = useIntl();
  const [accepted, setAccepted] = useState(false);

  const handleConfirm = () => {
    handleClose();
    confirmation();
  };

  return (
    <CustomModal id={id} isModalVisible={open} handleClose={handleClose}>
      <Container>
        <Header>
          <Title>
            {intl.formatMessage({
              id: isRemovingPermission
                ? "revoke_exhibitor_access"
                : "grant_exhibitor_access",
            })}
          </Title>
          <CloseButton type="button" onClick={handleClose}>
            <RiCloseLine size={20} />
          </CloseButton>
        </Header>

        <Description>
          {intl.formatMessage({
            id: isRemovingPermission
              ? "revoke_exhibitor_access_description"
              : "grant_exhibitor_access_description",
          })}
        </Description>

        <StyledCheckbox
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
        >
          {intl.formatMessage({ id: "modal_approval_checkbox_message" })}
        </StyledCheckbox>

        <Footer>
          <CancelButton type="button" onClick={handleClose}>
            {intl.formatMessage({ id: "cancel" })}
          </CancelButton>
          <ConfirmButton
            type="button"
            disabled={!accepted}
            onClick={handleConfirm}
          >
            {intl.formatMessage({
              id: isRemovingPermission ? "revoke_access" : "grant_access",
            })}
          </ConfirmButton>
        </Footer>
      </Container>
    </CustomModal>
  );
};

export default GrantExhibitorAccessModal;
